<template>
  <div>
    <label>Origem do cliente</label>

    <div class="w3-row">
      <div class="w3-col s4 l2">
        <input
          type="text"
          @keyup.enter="inserirDadoPorChave(undefined)"
          ref="cliente"
          class="w3-input w3-border input-codigo"
          v-model="chave_pesquisa"
          :disabled="somenteLeitura == 'S'"
          v-bind:placeholder="placeholder_codigo"
          v-on:blur="verificarCampoPesquisa()"
          maxlength="15"/>
      </div>

      <div class="w3-col s8 l10">
        <div class="input-container">
          <input
            class="input-cliente w3-border"
            type="text"
            v-model="nome_exibicao"
            @click="abrirPesquisaOrigensClientes"
            :disabled="somenteLeitura == 'S'"
            placeholder="Clique para selecionar o cliente"
            readonly>

          <i
            v-if="somenteLeitura == 'N'"
            class="fas fa-minus icone w3-border-top w3-border-right w3-border-bottom"
            @click="limparDados">
          </i>
        </div>
      </div>
    </div>

    <pesquisa-origens-clientes
      ref="pesquisaOrigensClientes"
      @confirmar="confirmarPesquisaOrigemCliente">
    </pesquisa-origens-clientes>
  </div>
</template>

<script>
  import toastr from 'toastr'
  import Biblioteca from '@/components/Repositorio/Biblioteca'
  import PesquisaOrigensClientes from '@/components/Pesquisas/PesquisaOrigensClientes'
  import ROrigemCliente from '@/components/Rest/ROrigemCliente'

  export default {
    name: 'FrameOrigemCliente',

    components: {
      toastr,
      PesquisaOrigensClientes
    },

    props: {
      somenteLeitura: {
        required: true,
        type: String,
        default: 'N'
      },

      origemClienteSelecionado: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      }
    },

    data() {
      return {
        origem_cliente_selecionado: {},
        nome_exibicao: '',
        chave_pesquisa: '',
        placeholder_codigo: 'Cód.'
      }
    },

    methods: {
      async inserirDadoPorChave(origem_cliente_id) {
        try {
          let parametro = Biblioteca.valorInt(origem_cliente_id);
          if (!parametro) {
            parametro = Biblioteca.valorInt(this.chave_pesquisa);
            if ((!parametro) || (parametro <= 0)) {
              toastr.error('Informe um código de grupo de clientes válido!');
              return;
            }
          }

          let parametros = {
            origem_cliente_id: parametro
          }

          let retorno = await ROrigemCliente.buscarOrigemClientePorId(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.confirmarPesquisaOrigemCliente(JSON.parse(JSON.stringify(retorno.dados)));
        }
        catch (e) {
          this.limparDados();
          toastr.error(e.message);
        }
      },

      abrirPesquisaOrigensClientes() {
        this.$refs.pesquisaOrigensClientes.abrir();
      },

      confirmarPesquisaOrigemCliente(origem) {
        this.origem_cliente_selecionado = JSON.parse(JSON.stringify(origem));

        this.chave_pesquisa = '';
        this.placeholder_codigo = Biblioteca.nPadrao(this.origem_cliente_selecionado.origem_cliente_id, 0);
        this.nome_exibicao = this.origem_cliente_selecionado.nome;
        
        this.$emit('confirmar', this.origem_cliente_selecionado);
      },
     
      limparDados() {
        this.chave_pesquisa = '';
        this.placeholder_codigo = 'Cód.';
        this.nome_exibicao = '';
        this.origem_cliente_selecionado = {};

        this.$emit('limparDados');
      },

      carregar(origem_cliente) {
        if ((!origem_cliente) || (!origem_cliente.origem_cliente_id)) {
          this.limparDados();
          return;
        }

        this.confirmarPesquisaOrigemCliente(JSON.parse(JSON.stringify(origem_cliente)));
      },

      valor(numero_str) {
        return Biblioteca.valor(numero_str);
      }
    },

    created() {
      if (this.origemClienteSelecionado) {
        this.carregar(this.origemClienteSelecionado);
      }
    }
  }
</script>

<style escoped>
  .card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    margin-bottom: 5px;
    padding: 3px !important;
  }

  .input-codigo {
    padding: 10px 15px;
    border-radius: 0px;
    position: relative;
    z-index: 0;
    background: #fff;
    font-weight: bold;
  }

  .input-container {
    display: -ms-flexbox; 
    display: flex;
    position: relative;
    z-index: 1;
    margin-left: -20px;
    width: calc(100% + 20px);
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .icone:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .input-cliente {
    width: 100%;
    padding: 10px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    border-right-style: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/Frames/FrameOrigemCliente.vue